// extracted by mini-css-extract-plugin
export var cartContainer = "_nf-4";
export var gray = "_nf-1";
export var itemContainer = "_nf-2";
export var itemDetails = "_nf-3";
export var strong = "_nf-0";